// extracted by mini-css-extract-plugin
export default {"header-container":"property-container_header-container__WdvIm","container":"property-container_container__Iz6BY"};